import {
  useNavigate,
  useSearchParams,
  useParams,
  type NavigateOptions,
} from "react-router-dom";
import { useStore } from "../store/globalState";
import { useSessionStore } from "../store/useSessionStore";

export const useRouteWithToken = () => {
  const { linkId: linkIdFromParams } = useParams<{
    linkId: string;
    flow: string;
  }>();
  const [searchParams] = useSearchParams();
  const { linkId: linkIdFromGlobalState } = useStore();
  const sessionLinkId = useSessionStore((s) => s.session.data?.linkId);

  const linkId =
    linkIdFromParams ||
    searchParams.get("linkId") ||
    linkIdFromGlobalState ||
    sessionLinkId;
  const navigate = useNavigate();

  const redirectTo = (route: string, options?: NavigateOptions) => {
    if (linkId) {
      const connector = route.includes('?') ? '&' : '/?';
      navigate(`${route}${connector}linkId=${linkId}`, options);
    } else {
      navigate(route, options);
    }
  };

  return { redirectTo, linkId };
};
